//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime, formatDate } from '../../components/helpers.js'
import { axiosPost } from '../../axios/axios.js'
import { prepareNewRequestInfo } from './RequestExecutorUtils'

export default {
  props: {
    request: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      loading: false,
      selectedEmployee: null,
      proposedEmployees: [],

      columns: null,
      pagination: {
        page: 1,
        rowsPerPage: 50
      }
    }
  },
  computed: {
    proposeByWorkSchedule: function () {
      return this.request._configuration.proposeExecutorsByWorkSchedule
    }
  },
  created: function () {
    this.columns = [
      {
        name: 'fio',
        label: 'ФИО',
        align: 'left',
        field: 'fio',
        sortable: true
      }
    ]

    const currentDate = new Date()
    currentDate.setHours(0, 0, 0, 0)
    const todayStartMillis = currentDate.getTime()
    const tomorrowStartMillis = todayStartMillis + 86400000

    if (this.proposeByWorkSchedule) {
      this.columns.push({
        name: 'today',
        label: formatDate(todayStartMillis) + ', ' + (new Date(todayStartMillis).toLocaleString('ru', { weekday: 'short' })), // 'Cегодня'
        align: 'left',
        field: 'workScheduleInfo',
        sortable: true,
        format: value => this.formatDayInfo(value, 'today')
      },
      {
        name: 'tomorrow',
        label: formatDate(tomorrowStartMillis) + ', ' + (new Date(tomorrowStartMillis).toLocaleString('ru', { weekday: 'short' })), // 'Завтра'
        align: 'left',
        field: 'workScheduleInfo',
        sortable: true,
        format: value => this.formatDayInfo(value, 'tomorrow')
      },
      {
        name: 'nextInterval',
        label: 'Планируемое отсутствие на рабочем месте',
        align: 'left',
        field: 'workScheduleInfo',
        sortable: true,
        format: (workScheduleInfo) => {
          const intervalInfo = workScheduleInfo && workScheduleInfo.nextInterval || null
          if (intervalInfo && intervalInfo.status) {
            const days = (intervalInfo.startDate - todayStartMillis) / 86400000

            let durationMessage = 'Через ' + days + ' дн.'
            if (intervalInfo.endDate !== intervalInfo.startDate) {
              durationMessage += 'с ' + formatDate(intervalInfo.startDate)
            } else {
              durationMessage += formatDate(intervalInfo.startDate)
            }
            if (intervalInfo.endDate) {
              if (intervalInfo.endDate !== intervalInfo.startDate) {
                durationMessage += ' по ' + formatDate(intervalInfo.endDate)
              }
            } else {
              durationMessage += ' и продлится более месяца'
            }
            return {
              shiftStatusName: intervalInfo.statusName,
              durationMessage
            }
          }
          return null
        }
      })
    } else {
      this.columns.push({
        name: 'startWorkTime',
        label: 'Время начала работы',
        align: 'left',
        field: 'startWorkTime',
        sortable: true,
        format: this.formatDateTime
      },
      {
        name: 'endWorkTime',
        label: 'Время завершения работы',
        align: 'left',
        field: 'endWorkTime',
        sortable: true,
        format: this.formatDateTime
      },
      {
        name: 'engineerScore',
        label: 'Инженерный уровень',
        align: 'center',
        field: 'engineerScore',
        sortable: true
      },
      {
        name: 'skills',
        label: 'Навыки',
        align: 'left',
        field: 'skills',
        sortable: false
      })
    }

    this.load()
  },
  methods: {
    formatDateTime: function (millis) {
      return millis != null ? convertTime(millis) : ''
    },
    formatEmployeeSkills: function (skills) {
      const names = []
      if (skills) {
        for (let i = 0; i < skills.length; i++) {
          names.push(skills[i].name + ' (' + skills[i].level + ')')
        }
      }
      return names
    },
    formatDayInfo: function (workScheduleInfo, dayKey) {
      const result = {}
      const dayInfo = workScheduleInfo && workScheduleInfo[dayKey] || null
      if (dayInfo) {
        if (!['vacation', 'illness', 'mobilized'].includes(dayInfo.status)) {
          result.dayStatusName = dayInfo.dayOn ? 'Рабочий' : dayInfo.status !== 'dayOff' ? 'Нерабочий' : ''

          if (dayInfo.dayOn && dayInfo.workShift) {
            const workShiftData = dayInfo.workShift
            if (workShiftData.startHour != null && workShiftData.endHour != null) {
              let endHour = workShiftData.endHour
              if (endHour > 24) {
                endHour -= 24
              }
              result.workShiftTime = workShiftData.startHour + '-' + endHour
            } else {
              const index = dayInfo.workShiftKey.indexOf('.')
              if (index != -1) {
                result.workShiftTime = dayInfo.workShiftKey.substring(index + 1)
              }
            }
          }
        }

        if (dayInfo.status && dayInfo.status !== 'work') {
          result.shiftStatusName = dayInfo.statusName

          if (dayInfo.statusInterval) {
            const startDate = dayInfo.statusInterval.startDate
            const endDate = dayInfo.statusInterval.endDate
            if (endDate) {
              if (startDate && (endDate !== startDate || !startDate)) {
                result.durationMessage = 'До ' + formatDate(endDate)
              }
            } else {
              result.durationMessage = 'Продлится более месяца'
            }
          }
        }
      }
      return result
    },

    load: function (callback) {
      let url
      const bodyFormData = new FormData()
      if (typeof this.request.requestId === 'number') {
        url = '/service/delta/request/proposeRequestEmployees'
        bodyFormData.set('requestId', this.request.requestId)
      } else {
        url = '/service/delta/request/proposeEmployees'
        prepareNewRequestInfo(this.request, bodyFormData)
      }

      if (this.proposeByWorkSchedule) {
        bodyFormData.set('byWorkSchedule', true)
      }

      this.loading = true
      axiosPost({
        url: url,
        data: bodyFormData,
        config: {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        },
        onSuccess: (response) => {
          this.proposedEmployees = response.data.result
          this.selectedEmployee = null

          if (callback) {
            callback.call(this.proposedEmployees)
          }
        },
        onFailure: 'Ошибка загрузки сотрудников в офисе',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    onEmployeeSelect: function (row) {
      if (this.selectedEmployee) {
        this.selectedEmployee.selected = false
        if (this.selectedEmployee.key === row.key) {
          this.selectedEmployee = null
          return
        }
      }
      this.selectedEmployee = row
      row.selected = true
    },
    getSelectedEmployee: function () {
      return this.selectedEmployee
    },
    onConfirm: function () {
      if (this.proposeByWorkSchedule) {
        const selectedEmployee = this.selectedEmployee
        const workScheduleInfo = selectedEmployee.workScheduleInfo
        const dayInfo = workScheduleInfo && workScheduleInfo.today || null
        const tomorrowDayInfo = workScheduleInfo && workScheduleInfo.tomorrow || null

        const currentDate = new Date()
        const workShiftEnded = dayInfo && dayInfo.workShift && dayInfo.workShift.endHour < 24 && currentDate.getHours() >= dayInfo.workShift.endHour
        const tomorrowDayStatusName = tomorrowDayInfo ? tomorrowDayInfo.statusName : 'Неизвестен'

        if (dayInfo && dayInfo.status && (dayInfo.status !== 'work' || workShiftEnded)) {
          this.$d_ask({
            callback: async (data, action) => {
              if (action === 'yes') {
                this.confirm()
              }
            },
            warning: workShiftEnded
              ? [
                    `На сегодня смена закончена. Завтра статус смены: "${tomorrowDayStatusName}".`,
                    'Продолжить?'
              ]
              : [
                    `Текущий статус смены - «${dayInfo.statusName}».`,
                    'Продолжить?'
              ],
            buttons: {
              yes: 'Да',
              cancel: 'Отмена'
            }
          })
          return
        }
      }
      this.confirm()
    },
    confirm: function () {
      this.$emit('confirm', this.selectedEmployee)
    },
    onCancel: function () {
      this.$emit('cancel')
    },
    getTrClass: function (row) {
      if (this.selectedEmployee && this.selectedEmployee.key === row.key) {
        return 'tr-selected'
      }
      return ''
    }
  }
}

